import BaseProgram from "./base";

export default class EmptyProgram extends BaseProgram {
  canShowAdditionalMeetingMatching(): boolean {
    return false;
  }
  getTableColumnsForReimbursement(): any[] {
    return [];
  }
  canShowNoShowFilter(): boolean {
    return false;
  }
  canAdminMarkAsNoShow(): boolean {
    return false;
  }
  canAddSponsorship(): boolean {
    return false;
  }
  canManageMeetingCap(): boolean {
    return false;
  }
  canViewMeetingPurchases(): boolean {
    return false;
  }
  canRemoveOrgFromProgram(): boolean {
    return false;
  }

  canSendNotification(): boolean {
    return false;
  }
}
